// extracted by mini-css-extract-plugin
export var downArrow = "_9j-0";
export var label = "_9j-1";
export var treatmentCard = "_9j-3";
export var upArrow = "_9j-2";